// The two plan-LEG kinds of a multi-repo goal (plan 101-multi-repo-goal-legs), rendered since
// slice 12 gave those goals their surface. Their own module beside `./maintenance-tenancy.ts`,
// which is at the file-size bound and only lists them.
//
//   `plan.leg_deployed` (ok)   — one leg's merge went live in the environment a `deployed`
//                                edge waits on (`@developerz/audit` `planLegDeployedDrafts`).
//   `plan.leg_released` (info) — an upstream leg merged or went live and its `hold: merge`
//                                dependents may now merge (the worker's `planLegReleasedDraft`).
//
// Each declines (null) a row that does not carry the fields its draft writes.

import type { TerminalRenderContext, TerminalRendered } from '../../../wire/terminal';
import { rec, str } from './maintenance-payload';

export function renderPlanLegDeployed(ctx: TerminalRenderContext): TerminalRendered | null {
  const { input } = ctx.row;
  const planId = str(input, 'planId');
  const group = str(input, 'groupId');
  const environment = str(input, 'environment');
  const repo = str(input, 'repoFullName');
  if (planId === null || group === null || environment === null || repo === null) return null;
  return {
    line: { key: 'terminal.plan.leg_deployed', params: { group, environment, repo } },
    subject: { kind: 'plan', id: planId, label: planId },
    refs: { planId, repoFullName: repo },
  };
}

export function renderPlanLegReleased(ctx: TerminalRenderContext): TerminalRendered | null {
  const planId = str(ctx.row.input, 'planId');
  const group = str(ctx.row.input, 'groupId');
  const released = str(ctx.row.output, 'released');
  const releasedFor = rec(ctx.row.output)?.['releasedFor'];
  if (planId === null || group === null || released === null) return null;
  if (!Array.isArray(releasedFor) || !releasedFor.every((g) => typeof g === 'string')) return null;
  return {
    line: {
      key: 'terminal.plan.leg_released',
      params: { group, released, dependents: releasedFor.join(', ') },
    },
    subject: { kind: 'plan', id: planId, label: planId },
    refs: { planId },
  };
}
